import React from 'react';
import ProductArea from "../components/ProductArea";
import Breadcrumbs from "../components/Breadcrumbs";
import Modal from "../components/Modal";
import SimilarProducts from "../components/SimilarProducts";
import ModalForm from "../components/ModalForm";
import {Helmet} from "react-helmet";
import {useSelector} from "react-redux";

const Product = () => {
    const title = useSelector(state => state.productDetail.product.title);
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{`${title} - Holz-City`}</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <Breadcrumbs/>
            <ProductArea/>
            <SimilarProducts/>
            <Modal/>
            <ModalForm/>
        </div>
    );
};

export default Product;